import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { setupInterceptor } from "./services/http";
// import KanbanBoardComponent from './app/components/KanbanBoard/KanbanBoardComponent';
setupInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />

  // </React.StrictMode>
);

// const excludedRoot = ReactDOM.createRoot(document.getElementById('excludedStrictMode'));
// excludedRoot.render(<KanbanBoardComponent />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
